/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ChatJobUpdateType {
    Queued = 0,
    InProgress = 1,
    Completed = 2,
    Failed = 3,
    Refused = 4,
}
